<template>
    <div class="common_contentBox">
        <div class="common_search">
            <el-row>
                <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
                    <span class="label">{{ $t('newApp.activityInfo.csl') }}：</span>
                    <div class="content">
                        <el-select v-model="forms.activityLayering" clearable>
                            <el-option v-for="item in activityLevelList" :key="item.fieldKey" :label="item.fieldValue"
                                :value="item.fieldKey" />
                        </el-select>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
                    <span class="label">{{ $t('eventList.Afc') }}：</span>
                    <div class="content">
                        <el-select v-model="forms.applyChannel" clearable>
                            <el-option v-for="item in afcList" :key="item.fieldKey" :label="item.fieldValue"
                                :value="item.fieldKey" />
                        </el-select>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
                    <span class="label">{{ $t('general.Status') }}：</span>
                    <div class="content">
                        <el-select v-model="forms.stat" clearable>
                            <el-option v-for="item in statusList" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </div>
                </el-col>
                <div class="btnBar">
                    <el-button plain @click="onreset">{{ $t('btn.Reset') }}</el-button>
                    <el-button type="primary" @click="searchBtn(true)">{{ $t('btn.Search') }}</el-button>
                </div>
            </el-row>
        </div>
        <div class="common_btnBar">
            <el-button type="primary" @click="addData">{{ $t('btn.Add') }}</el-button>
        </div>
        <commonTable ref="configTable" />
        <addConfigDialog :edit-data="rowData" :add-config-dialog-visible="addConfigDialogVisible"
            @dialogCloseHandle="addConfigDialogClose" :search="searchBtn" />
    </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import addConfigDialog from './component/ruleConfig/addConfigDialog.vue';
import { newApplicationFormApi, activityRuleApi } from '@/views/newApplicationForm/service';
export default {
    name: "ruleConfiguration",
    components: {
        commonTable,
        addConfigDialog,
    },
    data() {
        return {
            // 页面绑定
            forms: {},
            // 点击搜索后绑定
            form: {
                // activityLayering: '',
                // applyChannel: '',
                // stat: ''
            },
            activityLevelList: [],
            afcList: [
                {
                    fieldKey: '1',
                    fieldValue: '活动申请、活动报备'
                },
                {
                    fieldKey: '2',
                    fieldValue: '快捷申请'
                },
            ],
            statusList: [
                {
                    label: "开启",
                    value: 1
                }, {
                    label: "关闭",
                    value: 0
                }
            ],
            addConfigDialogVisible: false,
            rowData: {},
        };
    },
    methods: {
        init() {
            let params = [
                'activity_level'
            ];
            newApplicationFormApi.getActivityList(params).then(res => {
                this.activityLevelList = res.data.activity_level
            })
        },
        inputBoxFilter(e, key) {
            this.form[key] = e.target.value.trim();
        },
        addData() {
            this.rowData = {}
            this.addConfigDialogVisible = true;
        },
        addConfigDialogClose() {
            this.addConfigDialogVisible = false;
        },
        loadTable() {
            let tableRow = new TableRow();
            tableRow.push(
                new TableColumns()
                    ._width('14%')
                    ._title(this.$t('newApp.activityInfo.csl'))
                    // ._data('activityLayering')
                    ._cellType('customDom')
                    ._cellData({
                        formater: ({ row, column }) => {
                            const v = this.activityLevelList.find(item => item.fieldKey === row.activityLayering)?.fieldValue
                            return (v ? v : row.activityLayering);
                        }
                    }),
            );
            tableRow.push(
                new TableColumns()
                    ._width('14%')
                    ._title(this.$t('eventList.Afc'))
                    // ._data('applyChannel')
                    ._cellType('customDom')
                    ._cellData({
                        formater: ({ row, column }) => {
                            const v = this.afcList.find(item => item.fieldKey === row.applyChannel)?.fieldValue
                            return (v ? v : row.applyChannel);
                        }
                    }),
            );
            tableRow.push(
                new TableColumns()
                    ._width('14%')
                    ._title(this.$t('ruleConfig.ruleSort'))
                    ._data('sort')
            );
            tableRow.push(
                new TableColumns()
                    ._width('14%')
                    ._title(this.$t('newApp.ADList.CreationTime'))
                    ._data('createTime')
            );
            tableRow.push(
                new TableColumns()
                    ._width('14%')
                    ._title(this.$t('ruleConfig.createUser'))
                    ._data('createName')
            );
            tableRow.push(
                new TableColumns()
                    ._width('10%')
                    ._title(this.$t('general.Status'))
                    ._cellType('customDom')
                    ._cellData({
                        formater: ({ row, column }) => {
                            return (
                                <div>
                                    <el-switch
                                        v-model={row.stat}
                                        active-value={1}
                                        inactive-value={0}
                                        onChange={(val) => { this.setRowStat(row, val) }}
                                    >
                                    </el-switch>
                                </div>
                            );
                        }
                    }),
            );
            tableRow.push(
                new TableColumns()
                    ._width('10%')
                    ._title(this.$t('general.Operation'))
                    ._cellType('customDom')
                    ._cellData({
                        formater: ({ row, column }) => {
                            return (
                                <div>
                                    <el-button type="text" onClick={() => { this.editRow(row, column) }}>
                                        {this.$t("btn.Edit")}
                                    </el-button>
                                    <el-button type="text" onClick={() => { this.deleteRow(row, column) }}>
                                        {this.$t("btn.Delete")}
                                    </el-button>
                                </div>
                            );
                        }
                    }),
            );

            let column = tableRow._cols();
            this.$refs.configTable.setColumn(column, {
                resizable: true
            });

            this.$refs.configTable.loadTable({
                url: '/activity/apply/rule/page',
                listKey: "list",
                params: { condition: this.form }
            });
        },
        onreset() {
            this.forms = {};
            this.searchBtn(true);
        },
        searchBtn(first = false) {
            this.form = JSON.parse(JSON.stringify(this.forms))
            this.$refs.configTable.getTableData({
                url: '/activity/apply/rule/page',
                listKey: "list",
                params: { condition: this.form },
                // 携带first重置页码
                first: first
            });
        },
        editRow(row, column) {
            activityRuleApi.getById(row.id).then(res => {
                console.log(res)
                this.rowData = res.data
                this.addConfigDialogVisible = true;
            })
        },
        deleteRow(row, column) {
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                activityRuleApi.delById(row.id).then(res => {
                    console.log(res)
                    if (res.status === '200') {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        });
                    }
                    this.searchBtn()
                })
            }).catch(() => { });
        },
        setRowStat(row, val) {
            console.log(row, val)
            activityRuleApi.updateRule({
                id: row.id,
                activityLayering: row.activityLayering,
                applyChannel: row.applyChannel,
                sort: row.sort,
                stat: val,
                ruleCondition: row.ruleCondition
            }).then(res => {
                console.log(res)
                this.searchBtn()
            })
        }
    },
    computed: {},
    mounted() {
        this.init()
        this.loadTable();
    },

}
</script>

<style lang="scss"></style>